import { DataLakeQuery } from 'dashboard-services/api/dataLake'

import { useMutation, useQuery } from '@tanstack/react-query'

export default (() => {
  const useGetReviewByName = ({ getQueryBuilder, fileType, groupName, name, ...rest }) =>
    useQuery({
      ...DataLakeQuery.QUERIES.getReviewByName(getQueryBuilder, { fileType, groupName, name }),
      enabled: !!fileType && !!groupName && !!name,
      ...rest
    })

  const useUpdateReviewStatusByName = ({ getQueryBuilder, fileType, groupName, name, ...rest }) =>
    useMutation({
      ...DataLakeQuery.QUERIES.updateReviewStatusByName(getQueryBuilder, { fileType, groupName, name }),
      ...rest
    })

  const useDeleteReviewByName = ({ getQueryBuilder, fileType, groupName, name, ...rest }) =>
    useMutation({
      ...DataLakeQuery.QUERIES.deleteReviewByName(getQueryBuilder, { fileType, groupName, name }),
      ...rest
    })

  const useUpdateReviewCommentsByName = ({ getQueryBuilder, fileType, groupName, name, ...rest }) =>
    useMutation({
      ...DataLakeQuery.QUERIES.updateReviewCommentsByName(getQueryBuilder, { fileType, groupName, name }),
      ...rest,
      retry: false
    })

  return {
    useUpdateReviewCommentsByName,
    useDeleteReviewByName,
    useGetReviewByName,
    useUpdateReviewStatusByName
  }
})()
